import React, { useState } from "react";
import AlertMessage from "../../../../partials/alertMessage";

const NewBedForm = ({ onSubmit, onCancel }) => {
	//local state
	const [message, setMessage] = useState(null);
	// create reference
	const nameRef = React.createRef();
	const descRef = React.createRef();
	return (
		<form
			method="POST"
			onSubmit={e => {
				e.preventDefault();
				const name = nameRef.current.value;
				const desc = descRef.current.value;
				if (name && desc) {
					onSubmit({ name, desc });
					setMessage(null);
					// clear form
					nameRef.current.value = "";
					descRef.current.value = "";
				} else {
					setMessage("Name and description are required!");
					return;
				}
			}}
		>
			<div className="form-group row">
				<div className="col-sm-12">
					<AlertMessage message={message} failed={true} />
				</div>
				<label htmlFor="name" className="col-sm-4 col-form-label text-center">
					Name *
				</label>
				<div className="col-sm-8">
					<input
						type="text"
						ref={nameRef}
						className="form-control input-height"
						id="name"
					/>
				</div>
			</div>
			<div className="form-group row">
				<label
					htmlFor="description"
					className="col-sm-4 col-form-label text-center"
				>
					Description *
				</label>
				<div className="col-sm-8">
					<textarea
						className="form-control-textarea"
						name="desc"
						ref={descRef}
						id="description"
						cols="10"
						rows="4"
					></textarea>
				</div>
			</div>
			<div className="text-center m-b-20 m-t-20">
				<button
					type="button"
					onClick={() => onCancel()}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-10 margin-right-10 btn-circle"
				>
					<i className="material-icons text-danger">cancel</i> Cancel
				</button>
				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-10 btn-success btn-circle"
				>
					Submit <i className="material-icons">arrow_right_alt</i>
				</button>
			</div>
		</form>
	);
};
export default NewBedForm;
